import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { Message } from '@/types';

interface MessageHistoryViewProps {
  messages: Message[];
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  isFetchingNextPage?: boolean;
}

export function MessageHistoryView({
  messages,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
}: MessageHistoryViewProps) {
  return (
    <div className="flex flex-col gap-3">
      {hasNextPage && (
        <div className="flex justify-center">
          <Button
            variant="outline"
            size="sm"
            onClick={fetchNextPage}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Loading...
              </>
            ) : (
              'Load More'
            )}
          </Button>
        </div>
      )}

      {messages.map((message) => {
        const isInbound = (message.direction as string) === 'inbound' || (message.direction as string) === 'INCOMING';
        const phone = (message as any).fromNumber ?? message.senderPhoneNumber ?? '';
        return (
        <div
          key={message.id}
          className={cn(
            'rounded-lg p-3 max-w-[80%]',
            isInbound
              ? 'self-start text-left bg-muted'
              : 'self-end text-right bg-primary text-primary-foreground'
          )}
        >
          <p className="text-sm break-words">{message.content}</p>
          <div
            className={cn(
              'mt-1 flex items-center gap-2 text-xs',
              isInbound
                ? 'text-muted-foreground'
                : 'text-primary-foreground/70'
            )}
          >
            <span>{phone}</span>
            <span>·</span>
            <time dateTime={message.timestamp}>
              {new Date(message.timestamp).toLocaleString()}
            </time>
          </div>
        </div>
        );
      })}

      {messages.length === 0 && (
        <p className="text-center text-sm text-muted-foreground py-8">
          No messages to display.
        </p>
      )}
    </div>
  );
}
